<template>

<kt-select
    :label="props.label"
    placeholder="Select a user"
    label-key="TechnicianName"
    value-key="Id"
    :options="techs"
    v-model="model"
    @change="$emit('change', $event)"
    input-class="form-control-sm"
    suffix-class="p-0"
    :disabled="props.disabled"
>

<template #suffix>
    <!-- edit tech -->
    <button 
        v-if="model && !props.disabled"
        class="btn btn-sm btn-outline-secondary mt-auto rounded-start-0 rounded-end-0" 
        @click="editTech(model)"
    ><i class="fa fa-edit"></i>
    </button>

    <!-- new tech -->
    <button 
        v-if="!props.disabled"
        class="btn btn-sm btn-outline-primary mt-auto rounded-start-0" 
        @click="editTech()"
    ><i class="fa fa-plus"></i>
    </button>
</template>

</kt-select>

<kt-modal
    :visible="formVisible"
    :title="formTitle"
    @dismiss="formDismiss()"
>
    <template #body>
        <tech-form
            v-model="form"
        ></tech-form>
    </template>

    <template #footer>
        <div class="container-fluid px-0">
            <div class="row">
                <div class="col">
                    <button 
                        @click="formDismiss()" 
                        class="btn btn-sm btn-outline-secondary form-control"
                    >Close</button>
                </div>
                <!-- deletion button ...
                <div class="col-4" v-if="extraRecord.Id">
                    <button @click="extraDelete()" class="btn btn-sm btn-outline-danger form-control">Delete</button>
                </div>
                -->
                <div class="col">
                    <button 
                        @click="formSave(form)" 
                        class="btn btn-sm btn-outline-primary form-control"
                    >Save</button>
                </div>
            </div>
        </div>
    </template>
</kt-modal>

</template>

<script setup>

import { ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useTechStore } from "@/stores/TechStore";
// import Events from "@/services/Events.js";
import TechForm from "@/components/Techs/TechForm.vue";
import KtSelect from "@/components/UI/KtSelect.vue";
import KtModal from "@/components/UI/KtModal.vue";
import Api from "@/services/Api";

const techStore = useTechStore();
const { list } = storeToRefs(techStore);
const techs = ref([]);

const form = ref({});
const formVisible = ref(false);
const formTitle = ref("Edit Tech");

const props = defineProps(
{ 
    "label": {
        type: String,
        default: "Select User"
    },

    "active": {
        type: String,
        default: ""
    },

    "disabled": {
        type: Boolean,
        default: false
    },

    "readonly": {
        type: Boolean,
        default: false
    }
});

const model = defineModel({
    type: String,
    default: "",
});

const emits = defineEmits(["change"]);

/*
Events.on("reload:techs", async() =>
{
    await techStore.reload();
});
*/

const formDismiss = () =>
{
    formVisible.value = false;
}

const formSave = async (rec) =>
{
    await Api.saveTech(rec);
    await techStore.reload();

    formVisible.value = false;
};

const editTech = async (val) =>
{
    if (val)
    {
        formTitle.value = "Edit Tech";
        form.value = await Api.loadTech(val);
    }
    
    else
    {
        formTitle.value = "New Tech";
        form.value = {};
    }

    formVisible.value = true;
};

onMounted(async() =>
{
    // probably don't need to load every time ...
    await techStore.reload();

    if (props.active)
    {
        techs.value = await techStore.getActive();
    }

    else 
    {
        techs.value = list.value;
    }

});

</script>